import { createContext, useContext, useState, useEffect } from 'react';
import api from '../services/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [realUser, setRealUser] = useState(null);
  const [loading, setLoading] = useState(true);
  // Admin-only "view as" — overrides the role the UI sees so an admin can preview
  // what another role's screens look like. Client-side only: API calls still run
  // as the real admin (every role-gated endpoint also allows admin).
  const [viewAs, setViewAsState] = useState(() => localStorage.getItem('viewAsRole') || null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    const stored = localStorage.getItem('user');
    if (token && stored) setRealUser(JSON.parse(stored));
    setLoading(false);
  }, []);

  function setViewAs(role) {
    if (role && role !== 'admin') localStorage.setItem('viewAsRole', role);
    else localStorage.removeItem('viewAsRole');
    setViewAsState(role && role !== 'admin' ? role : null);
  }

  async function login(email, password) {
    const { data } = await api.post('/auth/login', { email, password });
    localStorage.setItem('token', data.token);
    localStorage.setItem('user', JSON.stringify(data.user));
    setViewAs(null);
    setRealUser(data.user);
    return data.user;
  }

  function loginWithToken(token, user) {
    localStorage.setItem('token', token);
    localStorage.setItem('user', JSON.stringify(user));
    setViewAs(null);
    setRealUser(user);
  }

  function logout() {
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    setViewAs(null);
    setRealUser(null);
  }

  // Only a real admin can view as another role; everyone else gets their own role.
  const user = realUser && realUser.role === 'admin' && viewAs
    ? { ...realUser, role: viewAs }
    : realUser;

  return (
    <AuthContext.Provider value={{ user, realUser, viewAs, setViewAs, login, loginWithToken, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
